import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import FormControl from "@mui/material/FormControl";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { fontSize } from "@mui/system";

const DivNewInvoiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 6px;
  padding: 14px;
  button {
    margin: 0px 5px;
  }
`;

function Forms() {
  let token = localStorage.getItem("Token");
  let user_id = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");
  const [url, setHost] = useState(APIModel.URL);

  if (user_status === "user") {
    return <Redirect to="/payment"></Redirect>;
  } else {
    return (
      <div className="wrapper">
        <SideNav />
        <div className="main-panel">
          <div className="content">
            <div className="container-fluid">
              <DivNewInvoiceHeader>
                <h3 className="font-weight-bold my-0">Liens Contract Forms</h3>
              </DivNewInvoiceHeader>
              <div className="bg-white rounded p-3">
                <div className="container">
                  <div>
                    <ol className="forms">
                      <li>
                        <a
                          href={url + "form1/" + user_id}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          California Preliminary 20-Day Notice
                        </a>
                      </li>
                      <li>
                        <a
                          href={url + "form2/" + user_id}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Conditional Waiver And Release On Final Payment
                        </a>
                      </li>
                      <li>
                        <a
                          href={url + "form3/" + user_id}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Conditional Waiver And Release On Progress Payment
                        </a>
                      </li>
                      <li>
                        <a
                          href={url + "form4/" + user_id}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Unconditional Waiver And Release On Final Payment
                        </a>
                      </li>
                      <li>
                        <a
                          href={url + "form5/" + user_id}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Unconditional Waiver And Release On Progress Payment
                        </a>
                      </li>
                      {/* <li><a href={url+'form6/'+user_id} target="_blank" rel="noreferrer noopener">Additional Work Authorization</a></li> */}
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Forms;
